import { Box, Grid, Typography } from "@mui/material";
import React from "react";

import "../../details/detailGrid/history/history.scss";
import AvatarSection from "./AvatarSection";
import HistoryDetails from "./HistoryDetails";
import { useFeedActorMeta } from "../hooks/useFeedActorMeta";

function FeedAssign({ history, showIcon = false, boardName }) {
  const { formattedDate, isMobile } = useFeedActorMeta({
    user: history?.response_object?.user_object,
    date: history?.at_time,
  });

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={2}
        sx={{
          width: isMobile
            ? "calc(100% - 10px) !important"
            : "calc(100% + 16px) !important",
        }}
        className="worklog-item d-flex justify-content-space-between">
        <Grid
          item
          xs={isMobile ? 12 : 8}
          className="feed-assignee"
          sx={{ paddingLeft: isMobile && "8px !important" }}>
          <div className="d-flex w-100">
            <AvatarSection history={history} showIcon={showIcon} />
            <HistoryDetails
              history={history}
              boardName={boardName}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={isMobile ? 12 : 4}
          sx={{ paddingTop: isMobile && "0px !important" }}>
          <div className={"d-flex align-items-center justify-content-end"}>
            <p className="worklog-date-time comment-date comment">
              Updated on{" "}
            </p>
            <Typography className="worklog-date-time comment-date">
              {formattedDate}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(FeedAssign);
